import { useEffect, useState } from 'react';

const useFirstLoading = (
  value: any,
  refreshKey = '',
  callback?: () => void,
) => {
  const [firstLoading, setFirstLoading] = useState(true);

  useEffect(() => {
    setFirstLoading(true);
  }, [refreshKey]);

  useEffect(() => {
    if (!firstLoading) return;
    if (value) {
      setFirstLoading(false);
      if (callback) callback();
    }
  }, [callback, firstLoading, value]);

  return firstLoading;
};

export default useFirstLoading;
